import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import type { ProdutoBody } from '../types/ProdutoBody';
import { invalidateProdutoQueries } from '../util/invalidateProdutoQueries';

const ProdutoPostSchema = z.object({
    pro_codigo_interno: z.number(),
    pro_idpk: z.number(),
    pro_produto_regra_fiscal_idpk: z.number().nullable(),
});

const schema = registrosSchema(ProdutoPostSchema);

function apiProdutoPost({ body }: { body: ProdutoBody }) {
    return fetchApi({
        body,
        endpoint: 'Produto/Produto',
        method: 'post',
        schema,
    });
}

export function useMutationProdutoPost() {
    return useMutation({
        mutationFn: apiProdutoPost,
        onSuccess: invalidateProdutoQueries,
    });
}
